
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/assets",
      function () {
        return require("private-next-pages/docs/assets/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/assets"])
      });
    }
  